export default __webpack_public_path__ + "static/media/SEC2060.34I-43068_-25736_0.913a187d.jpg";